export enum CapabilityIdEnum {
  Answer = 1,
  Actions = 2,
  Statistics = 4,
  Publish = 8,
  ProcessHelpRequests = 32,
  Route = 512,
  TagVIP = 1024,
  Automation = 2048,
  Marketing = 4096,
  ReadOnly = 8192,
  Engagement = 16384,
}
